<script>
import TitleWithRow from '@/components(new)/UI/Typography/TitleWithRow/TitleWithRow.vue'
import InputSelect from '@/components(new)/UI/Forms/InputSelect/InputSelect.vue'
import Label from '@/components(new)/UI/Forms/Label/Label.vue'
import Card from '@/components(new)/UI/Cards/Card/Card.vue'

export default {
  components: {
    TitleWithRow,
    InputSelect,
    Label,
    Card
  },

  props: {
    nomeAba: {
      default: 'ILPF/Lavoura'
    },
    culturas: {
      type: Array,
      required: true
    },
    pratica: {
      required: true
    }
  },
  data () {
    return {
      atividade: {
        cultura: '',
        espacamento: '',
        especificacaoOutros: ''
      }
    }
  },
  computed: {
    disableButton () {
      return !(
        this.atividade.cultura &&
        this.atividade.espacamento &&
        ((this.containsOption(this.atividade.cultura, 'OUTROS', 'especificacaoOutros') && this.atividade.especificacaoOutros) || !this.containsOption(this.atividade.cultura, 'OUTROS', 'especificacaoOutros'))
      )
    }
  },
  methods: {
    containsOption (parent, option, model) {
      let contains

      if (!Array.isArray(parent)) {
        contains = parent === option
      } else {
        contains = parent.includes(option)
      }

      if (!contains) {
        const props = model.split('.')
        const lastProp = props.pop()
        const target = props.reduce((acc, curr) => acc?.[curr], this.atividade)
        if (target && lastProp) {
          target[lastProp] = null
        }
      }
      return contains
    },
    btnAdicionar () {
      this.pratica.lavouras.push({
        ...this.atividade
      })
      this.atividade = {
        cultura: '',
        espacamento: '',
        especificacaoOutros: ''
      }
    },
    btnApagar (index) {
      this.pratica.lavouras.splice(index, 1)
    },
    btnEditar (lavoura, index) {
      this.atividade = {
        cultura: lavoura.cultura,
        espacamento: lavoura.espacamento,
        especificacaoOutros: lavoura.especificacaoOutros
      }
      this.btnApagar(index)
    }
  }
}
</script>

<template>
  <div>
    <TitleWithRow title="Atividades agrícolas e produtividade" />
    <el-row :gutter="20">
      <InputSelect
        :label="'Cultura'"
        :nomeAba="nomeAba"
        :obrigatorio="true"
        :rulesInput="!pratica.lavouras.length ? 'required' : ''"
        :opcoes="culturas"
        v-model="atividade.cultura"
        :widthColumn="8"
      />

      <validation-provider :rules="!pratica.lavouras.length ? 'required' : ''" v-slot="{ errors }" :name="nomeAba + '/Qual cultura '">
        <el-col :span="8" v-if="containsOption(atividade.cultura, 'OUTROS', 'especificacaoOutros')">
          <Label label="Qual cultura?" :obrigatorio="!pratica.lavouras.length" />
          <el-input
            v-model="atividade.especificacaoOutros"
            style="width: 100%"
            clearable
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>

      <validation-provider :rules="!pratica.lavouras.length ? 'required' : ''" v-slot="{ errors }" :name="nomeAba + '/Espaçamento '">
        <el-col :span="8">
          <Label label="Espaçamento (m)" :obrigatorio="!pratica.lavouras.length" />
          <el-input
            v-model="atividade.espacamento"
            placeholder="Ex: 20 x 20"
            style="width: 100%"
            clearable
            :class="{'input erro' : errors.length}"
          />
          <span v-if="errors[0]" class="help erro"> {{ errors[0] }}</span>
        </el-col>
      </validation-provider>
    </el-row>

    <el-row style="width: 100%; top: 20px; display: flex; justify-content: flex-end;">
      <el-button
        :disabled="disableButton"
        round type="primary"
        @click="btnAdicionar()"
      >
        Adicionar
      </el-button>
    </el-row>
    <div style="display: flex; flex-wrap: wrap;">
      <div v-for="(l, i) in pratica.lavouras" :key="i+l.cultura">
        <Card
          :objeto="{
            ...l,
            cultura: pratica.lavouras ? culturas.find(lavoura => lavoura.id === l.cultura).nome : '-'
          }"
          :deletar="() => btnApagar(i)"
          :editar="() => btnEditar(l, i)"
          titulo="Lavoura"
        />
      </div>
    </div>
  </div>
</template>



// WEBPACK FOOTER //
// src/components(new)/UI/Forms/ILPF/IlpfLavoura.vue